import React from "react";

import { useState } from "react";
import { useEffect } from "react";
import { getUserData } from "../../utils/localStorage";
import { useLocation, useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import SuccessModal from "../SuccessModal";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { getQrCodeByItem, getQrCodeCustomerSingleOrder } from "../../services/QrCode/getQrCode";
import { formatDateWithTime } from "../../constants/DateUtil/DateUtil";

const QrCodeByItem = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { storeCustomerId, bookingOrderId, orderItemId,customerALLOrdersData,isOrders } = location.state || {}; // Fallback to prevent undefined errors

  const { brandProfileData, storeData, userProfileData, userProfileRole } =
    getUserData();
  let storeId = storeData.id;

  const userRole = userProfileRole;

  const [tagInfo, setTagInfo] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [apiResStatus, setApiResStatus] = useState(false);

  const handleBackButton = () => {
    if (userRole === "BY_STORE") {
      if(orderItemId !== null ) {
      navigate("/OrdersGarmentInfo", {
        state: {
          storeCustomerId: storeCustomerId,
          bookingOrderId: bookingOrderId,
        },
      });
    } else if(isOrders === true) {
      navigate("/Orders")
    } else {
      navigate("/GetAllOrder", {
        state: {
          customerALLOrdersData,
          storeCustomerId,
        },
      })
    }
    } else if(isOrders === true) {
      navigate("/Orders") 
    }
      else {
      navigate(-1);
    }
  };

  const fetchQrCode = () => {

    if(orderItemId !== null ) {
   
    getQrCodeByItem(storeCustomerId, storeId, bookingOrderId, orderItemId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data.map((item) => ({
            ...item,
            checked: false,
          }));
          setTagInfo(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
    } else {
      
    getQrCodeCustomerSingleOrder(
      storeCustomerId,
      storeId,
      bookingOrderId
    )
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data.map((item) => ({
            ...item,
            checked: false,
          }));
          setTagInfo(Res);
        }
      })
      .catch((err) => {
        console.error("getCustomerSingleOrder Error:", err);
      });
    }
  };

  useEffect(() => {
    fetchQrCode();
  }, []);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermView, setSearchTermView] = useState(false);

  const filterUserList = () => {
    return tagInfo.filter((item) => {
      const qrcode = item.qrcode?.toLowerCase();
      const garmentAlias = item.garmentAlias?.toLowerCase();
      const garment = item.garment?.toLowerCase();
      const category = item.category?.toLowerCase();
      const matchesSearchTermQrcode = qrcode?.includes(
        searchTerm.toLowerCase()
      );
      const matchesSearchTermGarmentAlias = garmentAlias?.includes(
        searchTerm.toLowerCase()
      );
      const matchesSearchTermGarment = garment?.includes(
        searchTerm.toLowerCase()
      );
      const matchesSearchTermCategory = category?.includes(
        searchTerm.toLowerCase()
      );
      return (
        matchesSearchTermGarmentAlias ||
        matchesSearchTermGarment ||
        matchesSearchTermQrcode ||
        matchesSearchTermCategory
      );
    });
  };

  const filteredData = filterUserList();
 
  

  const OrderStatusColors = {
    BOOKED: "#3EB3E1",
    IN_PROCESS: "#866CCE",
    PROCESSED: "#F5C43A",
    DELIVERED: "#09B4AA",
    DONE: "#55BD5A",
    CANCEL: "#FF6767",
    UNPROCESSED: "#5D53D8",
    OUT_FOR_DELIVERY: "#6EA4F5",
    DELAY_STATUS: "#E89534",
    IN_WAREHOUSE: "#a906c2",
    DEFAULT: "#000",
  };

  const renderTagInfoItem = () => {
    return filteredData?.map((item, index) => {
      const garmentName =
        item.garmentAlias !== "" ? item.garmentAlias : item.garment;
        const orderStatusColor =
            OrderStatusColors[item.status] || OrderStatusColors.DEFAULT;
      let RFID = item.rfid ? " | " + item.rfid : "";
      return (
        <div>
          <div className="flex-1">
            <div className="py-2 px-4">
              <div className="flex justify-content-between align-items-center">
                <p className="text-xl font-medium">
                  {item.qrcode}
                  {RFID}
                </p>

                <p className="text-xl font-medium">
                  Updated On : {formatDateWithTime(item.lastModifiedDate)}
                </p>
              </div>
            </div>
            <div className="flex-1" style={{ backgroundColor: "#F6FAFF" }}>
              <div className="flex flex-row">
                <div className="flex-1 px-4">
                  <div>
                    <p
                      className="text-md font-normal"
                      style={{ color: "#75879B" }}
                    >
                      Garment :
                    </p>
                    <p className="text-lg font-medium">
                      {garmentName.replace(/_/g, " ")}
                    </p>
                  </div>
                </div>
                <div className="flex-1 px-4">
                  <div>
                    <p
                      className="text-md font-normal"
                      style={{ color: "#75879B" }}
                    >
                      Services :
                    </p>
                    <p className="text-lg font-medium">
                      {item.addOnList
                        .map((addOnItem) => addOnItem.serviceName)
                        .join(", ")}
                    </p>
                  </div>
                </div>
                <div className="flex-1 px-4">
                  <div>
                    <p
                      className="text-md font-normal"
                      style={{ color: "#75879B" }}
                    >
                      Category :
                    </p>
                    <p className="text-lg font-medium">
                      {item.category.replace(/_/g, " ")}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex flex-row">
                <div className="flex-1 px-4">
                  <div>
                    <p
                      className="text-md font-normal"
                      style={{ color: "#75879B" }}
                    >
                      Pack on :
                    </p>
                    <p className="text-lg font-medium">{item.garmentPack}</p>
                  </div>
                </div>
                <div className="flex-1 px-4">
                  <div>
                    <p
                      className="text-md font-normal"
                      style={{ color: "#75879B" }}
                    >
                      Remark :
                    </p>
                    <p className="text-lg font-medium">{item.remark}</p>
                  </div>
                </div>
                <div className="flex-1 px-4">
                  <div>
                    <p
                      className="text-md font-normal"
                      style={{ color: "#75879B" }}
                    >
                      Status :
                    </p>
                    <p
                      className="text-lg font-medium"
                      style={{ color: orderStatusColor }}
                    >
                      {item.status.replace(/_/g, " ")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
            <i
                  className="pi pi-angle-left cursor-pointer"
                  onClick={() => handleBackButton()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Garment Status
              </p>
            </div>
          </div>
          <div className="flex justify-content-center align-items-center mx-4 cursor-pointer">
            <i
              className="pi pi-search"
              onClick={() => setSearchTermView(!searchTermView)}
              style={{ fontSize: "25px", cursor: "pointer", color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      <div style={{ backgroundColor: "#fff" }}>
        {searchTermView && (
          <div>
            <div className="my-2 mx-5 flex flex-1">
              <IconField iconPosition="left" className="flex flex-1">
                <InputIcon className="pi pi-search text-lg"> </InputIcon>
                <InputText
                  placeholder="Search QrCode"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="text-xl flex flex-1 py-1"
                  style={{ borderRadius: 30 }}
                />
              </IconField>
              {searchTerm.length > 0 && (
              <div className="flex justify-content-center align-items-center mx-4 cursor-pointer" onClick={() => setSearchTerm("")}>
                <i
                  className={"pi pi-times"}
                  style={{
                    fontSize: "20px",
                    cursor: "pointer",
                    color: "red",
                  }}
                ></i>
              </div>
            )}
            </div>

            
          </div>
        )}
         
        <div className="flex-1" style={{ backgroundColor: "#EAEFF5" }}>
          <div className="flex-row py-2 px-4">
              <p className="text-2xl font-medium">Order Garment Info</p>
          </div>
        </div>

        <div>{renderTagInfoItem()}</div>
        <SuccessModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          status={apiResStatus === true ? "success" : false}
          text={
            apiResStatus === true
              ? "Selected Garment is Marked Ready!"
              : "Please try again later"
          }
        />
      </div>
      <div className="relative mt-8">
      </div>
    </div>
  );
};

export default QrCodeByItem;
